
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m15.725 13.525-1.1-1.1c.4333-1.1833.2083-2.1667-.675-2.95-.8833-.78333-1.8417-.98333-2.875-.6l-1.1-1.1c.2833-.18333.6-.31667.95-.4s.7083-.125 1.075-.125c1.1833 0 2.1875.4125 3.0125 1.2375s1.2375 1.8292 1.2375 3.0125c0 .3667-.0458.7292-.1375 1.0875s-.2208.6708-.3875.9375zm3.225 3.225-1-1c.8167-.6 1.5292-1.2708 2.1375-2.0125s1.0542-1.4875 1.3375-2.2375c-.8333-1.85-2.0833-3.3125-3.75-4.3875s-3.475-1.6125-5.425-1.6125c-.7 0-1.4167.06667-2.15.2-.73333.13333-1.30833.29167-1.725.475l-1.15-1.175c.58333-.26667 1.32917-.5 2.2375-.7.9083-.2 1.7958-.3 2.6625-.3 2.3833 0 4.5625.67917 6.5375 2.0375s3.4208 3.17917 4.3375 5.4625c-.4333 1.0667-.9917 2.0417-1.675 2.925s-1.475 1.6583-2.375 2.325zm1.45 5.65-4.2-4.125c-.5833.2333-1.2417.4125-1.975.5375s-1.475.1875-2.225.1875c-2.43333 0-4.64167-.6792-6.625-2.0375s-3.44167-3.1792-4.375-5.4625c.33333-.8667.79583-1.7125 1.3875-2.5375s1.3125-1.6125 2.1625-2.3625l-3.15-3.15 1.05-1.075 18.925 18.925zm-14.825-14.75c-.61667.45-1.2125 1.04167-1.7875 1.775-.575.7333-.9875 1.425-1.2375 2.075.85 1.85 2.12917 3.3125 3.8375 4.3875s3.6458 1.6125 5.8125 1.6125c.55 0 1.0917-.0333 1.625-.1s.9333-.1667 1.2-.3l-1.6-1.6c-.1833.0833-.4083.1458-.675.1875s-.5167.0625-.75.0625c-1.1667 0-2.16667-.4083-3-1.225s-1.25-1.825-1.25-3.025c0-.25.02083-.5.0625-.75s.10417-.475.1875-.675z","fill":"#4a3428"}})])
          )
        }
      }
    